import { Reveal } from "@/components/Motion";
import { MoveRight } from "lucide-react";

export default function ProcessFlow({ steps, dark = false, testid = "process-flow" }) {
  const items = steps.map((s) => (typeof s === "string" ? { label: s } : s));
  return (
    <ol data-testid={testid} className="flex flex-col gap-3 md:flex-row md:items-stretch md:gap-0">
      {items.map((step, i) => (
        <li key={step.label} className="flex flex-col md:flex-1 md:flex-row md:items-center">
          <Reveal delay={i * 0.08} className="flex-1">
            <div
              data-testid={`${testid}-step-${i + 1}`}
              className={`group relative h-full rounded-xl border p-5 transition-colors duration-300 ${
                dark
                  ? "border-slate-800 bg-navy-900/60 hover:border-cyan-500/50"
                  : "border-slate-200 bg-white hover:border-cyan-500/60 hover:shadow-lg hover:shadow-cyan-500/5"
              }`}
            >
              <span
                className={`font-mono text-xs font-semibold tracking-widest ${
                  dark ? "text-cyan-500" : "text-cyan-600"
                }`}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <p
                className={`mt-2 font-display text-lg font-semibold uppercase tracking-wide ${
                  dark ? "text-white" : "text-slate-900"
                }`}
              >
                {step.label}
              </p>
              {step.desc && (
                <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-slate-400" : "text-slate-500"}`}>
                  {step.desc}
                </p>
              )}
            </div>
          </Reveal>
          {i < items.length - 1 && (
            <span
              aria-hidden="true"
              className={`flex items-center justify-center py-1 md:px-2 md:py-0 ${
                dark ? "text-slate-600" : "text-slate-300"
              }`}
            >
              <MoveRight className="h-5 w-5 rotate-90 md:rotate-0" />
            </span>
          )}
        </li>
      ))}
    </ol>
  );
}
